/**
 * Same-tab notification that a chat unread count changed locally (e.g. a
 * conversation was opened and its unread_count zeroed optimistically).
 * Lets the sidebar nav badge (Sidebar.jsx's useChatUnread) refresh in step
 * with Chat.jsx's own local state instead of waiting only on a socket event
 * that may be missed (dropped, or the listener not yet attached at the time
 * it fires) — that gap is the pre-existing unread-badge desync bug.
 */
const listeners = new Set();

export function notifyChatUnreadChanged() {
  listeners.forEach((fn) => fn());
}

export function subscribeChatUnreadChanged(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
